export const STRING_SPLIT_CHAR = "|";
class StringUtils {
    camelCaseToWords(s: string) {
        const result = s.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
}

const stringUtils = new StringUtils();

export default stringUtils;
